import { signOut } from "firebase/auth";
import { auth } from "firebaseConfig";

const LogoutButton = () => {
    return (
        <button
            onClick={() => {
                signOut(auth).then(() => {
                    window.location.href = "/login";
                });
            }}
            style={{
                fontSize: "1rem",
                padding: ".5rem 1rem",
                border: "1px solid #ccc",
                backgroundColor: "#dbffdb",
                borderRadius: ".5rem",
                width: "5rem",
            }}
        >
            Log out
        </button>
    );
};

export default LogoutButton;
